export default __webpack_public_path__ + "static/media/barista.2f6a9042.jpg";